import LogStorage from './log-storage';
import { getUfId, getIpAddress, getCanalNome } from '../utils/helpers';

export default async function LoggerRevista({ env, options, router, store, EventBus }) {
  const meuIP = (await getIpAddress()) || 'block ip address';

  const logStorage = new LogStorage(env.apollo, meuIP, EventBus);

  // Start Log
  logStorage.init({
    uf: env.revista.uf,
    uf_id: getUfId(env.revista.uf),
    modulo: env.revista.modulo,
    navigator: window.navigator,
    canal: {
      id: env.revista.canal,
      nome: getCanalNome(env.revista.canal),
    },
    home: false,
    route: router.currentRoute,
  });

  // Router Change
  router.afterEach((to, from) => {
    const uf = window.localStorage.getItem('revista.uf');
    logStorage.init({
      uf,
      uf_id: getUfId(uf),
      modulo: env.revista.modulo,
      navigator: window.navigator,
      canal: {
        id: env.revista.canal,
        nome: getCanalNome(env.revista.canal),
      },
      home: false,
      route: to,
    });
  });

  // Change UF
  window.$emitter.$on('send.uf', uf => {
    console.log(env);
    const currentRoute = router.currentRoute;
    const uf_id = getUfId(uf);
    logStorage.init({
      uf,
      uf_id,
      modulo: env.revista.modulo,
      navigator: window.navigator,
      canal: {
        id: env.revista.canal,
        nome: getCanalNome(env.revista.canal),
      },
      home: false,
      route: currentRoute,
    });
  });
}
